import * as e from "react";
import { Fragment as t, jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/TextRun.tsx
var i = new Set([
	"ゃ",
	"ゅ",
	"ょ",
	"ぁ",
	"ぃ",
	"ぅ",
	"ぇ",
	"ぉ",
	"っ"
]), a = "⁠", o = {
	bold: "strong",
	italic: "em",
	underline: "u"
};
function s(e) {
	let s = e.part;
	if (typeof s == "string") return i.has(s[0]) ? /* @__PURE__ */ r(t, { children: [a, s] }) : /* @__PURE__ */ n(t, { children: s });
	switch (s.type) {
		case "ruby": return /* @__PURE__ */ n("span", { children: /* @__PURE__ */ r("ruby", { children: [/* @__PURE__ */ n(c, { content: s.baseText }), /* @__PURE__ */ n("rt", { children: /* @__PURE__ */ n(c, { content: s.annotation }) })] }) });
		case "tagged": return /* @__PURE__ */ n("span", {
			className: s.tags.length ? s.tags.join(" ") : void 0,
			children: /* @__PURE__ */ n(c, { content: s.content })
		});
		case "formatting": {
			let e = o[s.style];
			return /* @__PURE__ */ n(e, {
				[`data-formatted-text-${s.style}`]: !0,
				children: /* @__PURE__ */ n(c, { content: s.content })
			});
		}
	}
}
var c = e.memo((e) => e.content.map((e, t) => /* @__PURE__ */ n(s, { part: e }, t)));
c.displayName = "TextRun";
//#endregion
export { c as TextRun };
